import React, { Component } from 'react';
import Project from './project.jsx'
import TimeField from 'react-simple-timefield';
import moment from 'moment-jalaali';
import { SingleDatePicker } from 'react-dates';
import Startbtn from './startbtn.jsx';

moment.loadPersian({usePersianDigits: false, dialect: 'persian-modern'})

const initialStateObj = {
  name: '',
  startTime: moment().locale('en').format('HH:mm'),
  endTime: moment().locale('en').format('HH:mm'),
  date: moment().locale('fa')
}

class Manualcomponent extends Component {
  
  constructor(props){
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.clearState = this.clearState.bind(this)

    this.state = {
      obj: initialStateObj
    }
  }

  handleSubmit(e){
    e.preventDefault()
  }

  clearState(){
    this.setState({obj: initialStateObj})
  } 

  handleChange(e){
    this.setState({obj: { ...this.state.obj, name:e.target.value }})
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.manual_record.project.id){
      this.setState({obj: { ...this.state.obj, project:nextProps.manual_record.project }})
    }
  }

  render() {
    const {manual_record} = this.props || {}
    return (
      <div className="manual-component">
          <form onSubmit={this.handleSubmit}>
            <input type="text" placeholder="چه کاری انجام دادید؟" value={this.state.obj.name || ''} onChange={this.handleChange} className="record-dsc-input"/>
          </form>
          <Project active={true} selected={manual_record}></Project>
          <div className="manual-tools">
            <SingleDatePicker 
              small
              showDefaultInputIcon
              placeholder = 'تاریخ انجام'
              isRTL
              numberOfMonths={1}
              renderMonth={month => moment(month).format('jMMMM jYYYY')}
              renderDayContents={day => moment(day).format('jD')}
              hideKeyboardShortcutsPanel
              monthFormat="jYYYY jMMMM"
              date={this.state.obj.date}
              onDateChange={date => this.setState({obj: { ...this.state.obj, date }})}
              focused={this.state.focused}
              onFocusChange={({ focused }) => this.setState({ focused })}
              displayFormat={date => moment(this.state.obj.date).format('jMMMM jD')}
              isOutsideRange={()=>{}}
            />
            <form onSubmit={this.updateRecordData} className="manual-data-field">
              <TimeField title="شروع" value={this.state.obj.startTime} onChange={(startTime)=>{ this.setState({obj: { ...this.state.obj, startTime }}) }} />
              <i className="glyphicon glyphicon-arrow-left"></i>
              <TimeField title="پایان" value={this.state.obj.endTime} onChange={(endTime)=>{ this.setState({obj: { ...this.state.obj, endTime }}) }} />
            </form>
            <Startbtn manual={true} manualObj={this.state.obj} clearState={this.clearState} add={this.props.addManualRecord} timer_loading={this.props.timer_loading}/>
        </div>
      </div>
    );
  }
}


export default Manualcomponent;
